/* Built In Imports */
import { forwardRef, useEffect, useState } from 'react';
import NextLink from 'next/link';
/* External Imports */
import {
  Box,
  Flex,
  Button,
  Radio,
  RadioGroup,
  Text,
  Grid,
  useTab,
  FormControl,
  UnorderedList,
  useMultiStyleConfig,
  ListItem,
  Link,
} from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */
/* Styles */

/**
 * Renders ChypSadhanaDetail Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

export const pageCss = {
  en: {
    tabTitle: {
      fontSize: {
        base: '16px',
        md: '22px',
      },
      color: 'red',
    },
    testimonialHeight: 571,
    cardTitle: {
      lineHeight: {
        base: '1.5rem',
        md: '1.6rem',
      },
    },
  },
};
const ChypSadhanaDetail = ({ sectionContent, region, lang }) => {
  const [selectedProg, setSelectedProg] = useState(null);
  const [SelectProg, setSelectProg] = useState('21 Days');
  const [progUrl, setProgUrl] = useState('');
  const handleProgramRadio = (event, data) => {
    event.preventDefault();
    setSelectProg(data.RefName);
    emptySelection();
  };

  const emptySelection = () => {
    setProgUrl('');
    setSelectedProg(null);
  };

  const handleRadioClick = (event, data) => {
    event.preventDefault();
    if (data?.Status?.toLowerCase() !== 'full') {
      setProgUrl(data.Category);
      setSelectedProg(data);
    }
  };

  const cardStyle = {
    Open: {
      boxShadow: '0 0 2px #979797',
      background: '#FFFFFF',
    },
    Selected: {
      boxShadow:
        '0px 0px 0px 2px #be3a1d,3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593)',
      background: '#F5F0E5',
    },
    Full: {
      outline: 'none',
      boxShadow: 'none',
      background: '#F5F0E5',
    },
  };

  const CustomTab = forwardRef((props, ref) => {
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];

    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width="20px"
          display={isSelected ? 'block' : 'none'}
          height="11px"
          left="50%"
          style={{ transition: 'width 1s' }}
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };

    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#211637 !important' : '#7B7B7B  !important'}
        bg={isSelected ? '#FBAD2E' : '#E8DECB'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={pageCss[lang]?.tabTitle?.fontSize}
        lineHeight="150.3%"
        _active={{ bg: '#FBAD2E', border: '0' }}
        _focus={{ bg: '#FBAD2E', border: '0' }}
        pos="relative"
        height={{ base: '45px', sm: '81px' }}
        p={{ base: '0', sm: '1rem' }}
      >
        {tabProps.children}
      </Button>
    );
  });
  return (
    <>
      <Box m={{base:'16px auto 30px auto', md:'70px auto 60px auto'}} width={{ base: '100%', md: 'auto' }}>
        <Box>
          <SectionTitle titleObj={sectionContent[0]} />
        </Box>
        <Box
          fontFamily="FedraSansStd-book"
          maxW={{ base: '315px', md: '660px' }}
          m="0 auto"
        >
          <StructuredTextParser
            str={render(sectionContent[1]?.body)}
            region={region}
            lang={lang}
            mt="0"
            color={'#000000'}
            lineHeight={'1.7'}
            fontSize="16px"
            className=""
          />
        </Box>
        <Box
          fontFamily="FedraSansStd-book"
          maxW={{ base: '315px', md: '660px' }}
          m="0 auto"
        >
          <StructuredTextParser
            str={render(sectionContent[2]?.body)}
            region={region}
            lang={lang}
            mt="0"
            color={'#000000'}
            lineHeight={'1.7'}
            fontSize="16px"
            padding={'10px 0'}
            className="sadhana_details"
          />
        </Box>
        <Box
          maxWidth={{ base: '100%', md: '660px' }}
          margin="30px auto"
          bgColor={'#FCFAF6'}
          padding={{ base: '25px 16px', md: '40px 20px' }}
        >
          <Text
            fontFamily={'FedraSerifAStdBook'}
            fontSize={{ base: '20px', md: '24px' }}
            fontWeight={'600'}
            color={'#02026C'}
            textAlign={'center'}
          >
            {sectionContent[3]?.text}
          </Text>
          <Grid pt="30px">
            <FormControl>
              <RadioGroup value={SelectProg}>
                <Flex
                  placeContent="center"
                  gridGap={{ base: '15px', md: '30px' }}
                  gridRowGap={{ base: '15px', md: '30px' }}
                  flexWrap="wrap"
                  justifyContent={'center'}
                >
                  {sectionContent[4]?.data?.map((data, i) => {
                    return (
                      <Box
                        as="label"
                        key={nanoid(4)}
                        w={{ base: '146px', md: '152px', lg: '152px' }}
                        paddingLeft={{
                          base: '12px',
                          md: '16px',
                        }}
                        pr={{ base: '11.47px', md: '10px' }}
                        pt={{ base: '11px', md: '16px' }}
                        pb={{ base: '19px', md: '20px' }}
                        height={{base:'48px', md:'58px'}}
                        style={
                          data?.RefName === SelectProg
                            ? cardStyle.Selected
                            : data?.RefName === SelectProg
                            ? cardStyle.Full
                            : cardStyle.Open
                        }
                        position="relative"
                        borderRadius="6px"
                        onClick={event => handleProgramRadio(event, data)}
                        cursor={
                          data?.RefName === SelectProg ? 'cursor' : 'pointer'
                        }
                      >
                        <style>
                          {`
                            .radio{
                              border:0 !important;
                              background:transparent !important;
                            }
                            .radio:before{
                              background:#CF4520 !important;
                            }
                          `}
                        </style>
                        <Flex justifyContent="space-between">
                          <Box
                            fontFamily="FedraSansStd-medium"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize={{ md: '18px', base: '18px' }}
                            lineHeight="16px"
                            display="flex"
                            alignItems="center"
                            fontFeatureSettings="case"
                            color="#000000"
                          >
                            {data.days}
                          </Box>
                          <Radio
                            name="inComp"
                            id="radio1"
                            className="radio"
                            colorScheme="orange"
                            value={data.RefName}
                            boxShadow="0 0 0 1px #CF4520"
                            width="26px"
                            height="26px"
                            cursor="pointer"
                            isDisabled={
                              data?.RefName === SelectProg ? true : false
                            }
                          />
                        </Flex>
                      </Box>
                    );
                  })}
                </Flex>
              </RadioGroup>
            </FormControl>
          </Grid>
          {SelectProg === "21 Days" && (
            <Text
              fontFamily={"'FedraSansStd-book', sans-serif"}
              fontSize={{ base: '16px', md: '16px' }}
              fontWeight={'500'}
              color={'#000000'}
              textAlign={'center'}
              fontStyle={'italic'}
              width={{base:'295px', md:'auto'}}
              m={'20px auto 10px auto'}
            >
              <StructuredTextParser
                str={render(sectionContent[5]?.body)}
                region={region}
                lang={lang}
                mt="0"
                color={'#000000'}
                lineHeight={'1.7'}
                fontSize="16px"
                padding={'10px 0'}
                className="category_note"
              />
            </Text>
            )}
          <Text
            fontFamily={'FedraSerifAStdBook'}
            fontSize={{ base: '20px', md: '24px' }}
            fontWeight={'600'}
            color={'#02026C'}
            textAlign={'center'}
            m={{base:'20px auto 20px auto', md:'40px auto 20px auto'}}
          >
            {sectionContent[6]?.text}
          </Text>

          <Grid pt={{base:'0px', md:'0px'}}>
            <FormControl>
              <RadioGroup
                onChange={event => setProgUrl(event.target.value)}
                value={progUrl}
              >
                <Flex
                  placeContent="left"
                  gridGap={{ base: '7px', md: '30px' }}
                  gridRowGap={{ base: '15px', md: '30px' }}
                  mt="10px"
                  maxW="700px"
                  flexWrap="wrap"
                  flexDirection="row"
                  justifyContent={{base:'center', md:'inherit'}}
                >
                  {/* {sectionContent[selTab === 'yes' && selCity == 'Philadelphia' ? 36  : 34]?.data?.map( */}
                  {sectionContent[7]?.data?.map((data, i) => {
                    if (data?.RefName === SelectProg || !data.RefName) {
                      return (
                        <Box
                          as="label"
                          key={nanoid(4)}
                          w={{ base: '279px', md: '279px' }}
                          maxW="279px"
                          minW={{ base: '279px', md: '279px' }}
                          paddingLeft={{
                            base: '19px',
                            md: '19px',
                          }}
                          minH={{ base: '198px', md: '198px' }}
                          pr={{ base: '20px', md: '20px' }}
                          pt={{ base: '29px', md: '29px' }}
                          pb={{ base: '27px', md: '27px' }}
                          mb={{ base: '10px', md: '10px' }}
                          style={
                            progUrl === data.Category
                              ? cardStyle.Selected
                              : data?.Status?.toLowerCase() === 'full'
                              ? cardStyle.Full
                              : cardStyle.Open
                          }
                          position="relative"
                          borderRadius="10px"
                          onClick={event => handleRadioClick(event, data)}
                          cursor={
                            data?.Status?.toLowerCase() === 'full'
                              ? 'cursor'
                              : 'pointer'
                          }
                        >
                          {data?.Status?.toLowerCase() === 'full' && (
                            <Box
                              pos="absolute"
                              top={0}
                              right={0}
                              left={0}
                              bottom={0}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              textAlign="center"
                              background="#494949"
                              opacity="0.7"
                              borderRadius="10px"
                            >
                              <Text
                                color="#fff"
                                fontSize="24px"
                                fontFamily="FedraSansStd-medium"
                              >
                                FULL
                              </Text>
                            </Box>
                          )}
                          <style>
                            {`
                          .radio{
                            border:0 !important;
                            background:transparent !important;
                          }
                          .radio:before{
                            background:#CF4520 !important;
                          }
                          `}
                          </style>
                          <Flex justifyContent="space-between">
                            <Box
                              fontFamily="FedraSansStd-medium"
                              fontStyle="normal"
                              fontWeight="500"
                              fontSize={{ md: '20px', base: '20px' }}
                              lineHeight="16px"
                              display="flex"
                              alignItems="center"
                              fontFeatureSettings="case"
                              color="#000000"
                            >
                              {data.Category}
                            </Box>
                            <Radio
                              name="inComp1"
                              id="radio1"
                              className="radio"
                              colorScheme="orange"
                              value={data.Category}
                              boxShadow="0 0 0 1px #CF4520"
                              width="26px"
                              height="26px"
                              key={data.RefName}
                              cursor="pointer"
                              isDisabled={
                                data?.Status?.toLowerCase() === 'full'
                                  ? true
                                  : false
                              }
                            />
                          </Flex>
                          <Box
                            fontFamily="FedraSansStd-book"
                            background="#E4DED4"
                            fontWeight={'600'}
                            borderRadius="4px"
                            p={{ base: '4px 12px', md: '5px' }}
                            fontSize={{ base: '16px' }}
                            my="15px"
                            color="#000"
                            textAlign="left"
                            w="100%"
                            display="inline-flex"
                          >
                            <Box as="span" mr="10px">
                              {data.Price}
                            </Box>
                          </Box>

                          <Box>
                            <UnorderedList
                              fontStyle="normal"
                              fontWeight="400"
                              fontSize={{ base: '16px', md: '16px' }}
                              lineHeight={{ base: '20px', md: '20px' }}
                              fontFeatureSettings="case"
                              color="#28231E"
                              fontFamily="FedraSansStd-book"
                            >
                              {data.Descripton.value_1 && (
                                <ListItem mb="10px">
                                  {parser(data.Descripton.value_1 || '')}
                                </ListItem>
                              )}
                              {data.Descripton.value_2 && (
                                <ListItem mb="10px">
                                  {parser(data.Descripton.value_2 || '')}
                                </ListItem>
                              )}
                            </UnorderedList>
                          </Box>
                        </Box>
                      );
                    }
                  })}
                </Flex>
              </RadioGroup>
            </FormControl>
          </Grid>

          {sectionContent[8]?._modelApiKey === 'simple_button' && (
            <Box display="flex" placeContent="center" mt="16px">
              <Link
                href={
                  selectedProg?.LinkUrl
                    ? refineUrlDomain(`${selectedProg?.LinkUrl}`, region, lang)
                    : 'javascript:void()'
                }
                my="10px"
                display="block"
                fontWeight={'500'}
                fontFamily={'FedraSansStd-medium'}
                fontSize={'18px'}
                bgColor={progUrl ? '#cf4520' : '#cf452069'}
                h={'auto'}
                minH={{base:'50px', md:'50px'}}
                textAlign="center"
                padding={'11px 29px'}
                borderRadius="5px"
                color="#faf7f0"
                textDecoration="none"
                width={{base:'222px', md:'222px'}}
                cursor={progUrl ? 'pointer' : 'not-allowed'}
                _hover={{
                  bg: progUrl ? '#000054' : '',
                }}
                target={progUrl ? '_blank' : ''}
                className='register_btn'
              >
                {sectionContent[8]?.buttonText}
              </Link>
            </Box>
          )}
        </Box>
        <style global jsx>
          {`
            .sadhana_details h6 mark,
            .category_note p mark {
              color: #7c0514 !important;
              background: none;
            }
            .register_btn {
              height: 50px !important;
            }
            .sadhana_details h6 {
              font-weight: bold;
              margin-bottom: 20px;
              margin-top: 16px;
            }
            .category_note {
              font-size: 16px;
              font-weight: 600;
              padding-left: 30px;
            }
            .sadhana_details {
              margin-top: 5px;
            }
            .sadhana_details p {
              padding: 5px 0;
            }
            @media (max-width: 768px) {
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default ChypSadhanaDetail;
